import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../Components/Loader";
import SignUpForm from "../../Components/Forms/SignUpForm";
import SignUpFormTwo from "../../Components/Forms/SignUpFormTwo";
import "./style.css";
import AnimationSection from "../../Components/AnimationSection";
import Footer from "../../Layout/Footer";

const SignUp = () => {
  const [nextStep, setNextStep] = useState(false);
  const [data, setData] = useState();
  const handleNextStep = () => {
    setNextStep(true);
  };
  useEffect(async () => {
    const home = await axios.get(
      "https://staging-cms-main.ipurvey.com/homepage"
    );
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    setData([home.data, layout.data]);
  }, []);
  if (data) {
    return (
      <>
        <div className="user_acc_container">
          <div className="user_acc_md user_acc_s_md">
            <div className="user_acc_left_md">
              {!nextStep ? (
                <AnimationSection
                  data={data[0]}
                  forms={<SignUpForm data={data[1]} onClick={handleNextStep} />}
                />
              ) : (
                <AnimationSection
                  data={data[0]}
                  forms={<SignUpFormTwo data={data[1]} />}
                />
              )}
            </div>
          </div>
        </div>
        <Footer data={data[1]} />
      </>
    );
  } else {
    return <Loader />;
  }
};

export default SignUp;
